import { z } from 'zod';

/** Item de `GET {CREDIT_API_URL}/Permission` (permissões efetivas do usuário logado). */
export const permissionEntrySchema = z.looseObject({
  resourceDisplay: z.string(),
  type: z.number(),
  level: z.number(),
  principalId: z.string().nullish(),
  typeDisplay: z.string().nullish(),
  levelDisplay: z.string().nullish(),
});

export const permissionListSchema = z.array(permissionEntrySchema);

export type PermissionEntry = z.infer<typeof permissionEntrySchema>;
